(() => {
  const landing = document.querySelector('.shabima-landing-v1-page');
  if (!landing) return;

  const formatMoney = (cents, root) => {
    const locale = root.dataset.locale || 'es-CO';
    const currency = root.dataset.currency || 'COP';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(Number(cents) / 100);
    } catch (_) {
      return `$${Math.round(Number(cents) / 100).toLocaleString('es-CO')}`;
    }
  };

  const updatePrice = () => {
    const root = landing.querySelector('[data-shabima-price-root]');
    const data = landing.querySelector('[data-shabima-price-variants]');
    if (!root || !data) return;

    let variants;
    try {
      variants = JSON.parse(data.textContent);
    } catch (_) {
      return;
    }

    const variantInput = landing.querySelector('product-form input[name="id"], form[action*="/cart/add"] input[name="id"]');
    const variantId = variantInput?.value || new URLSearchParams(window.location.search).get('variant');
    const variant = variants.find(item => String(item.id) === String(variantId)) || variants[0];
    if (!variant) return;

    const price = Number(variant.price || 0);
    const compare = Number(variant.compare_at_price || 0);
    const hasDiscount = compare > price && price > 0;
    const savings = hasDiscount ? compare - price : 0;
    const discount = hasDiscount ? Math.round((savings * 100) / compare) : 0;

    const currentNode = root.querySelector('[data-shabima-current]');
    const compareNode = root.querySelector('[data-shabima-compare]');
    const discountNode = root.querySelector('[data-shabima-discount]');
    const savingNode = root.querySelector('[data-shabima-saving]');
    const savingValueNode = root.querySelector('[data-shabima-saving-value]');

    if (currentNode) currentNode.textContent = formatMoney(price, root);
    if (compareNode) {
      compareNode.hidden = !hasDiscount;
      if (hasDiscount) compareNode.textContent = formatMoney(compare, root);
    }
    if (discountNode) {
      discountNode.hidden = !hasDiscount;
      if (hasDiscount) discountNode.textContent = `−${discount}%`;
    }
    if (savingNode) savingNode.hidden = !hasDiscount;
    if (savingValueNode && hasDiscount) savingValueNode.textContent = formatMoney(savings, root);
  };

  updatePrice();
  document.addEventListener('change', event => {
    if (!landing.contains(event.target)) return;
    [0, 80, 220].forEach(delay => window.setTimeout(updatePrice, delay));
  });
  document.addEventListener('variant:change', updatePrice);
})();

(() => {
  const WRITE_SEL = '.jdgm-write-rev-link, [data-jdgm-target="write-review"], .jdgm-write-rev-wrap';
  const WIDGET_SEL = '.jdgm-widget, .jdgm-rev-widg';

  const move = () => {
    const widget = document.querySelector(WIDGET_SEL);
    if (!widget) return false;
    const link = widget.querySelector(WRITE_SEL);
    if (!link) return false;
    if (widget.lastElementChild !== link && !widget.lastElementChild?.contains(link)) {
      widget.appendChild(link);
    }
    return true;
  };

  const section = document.querySelector('.shabima-reviews-section');
  if (!section) return;

  if (move()) return;

  const obs = new MutationObserver(() => move());
  obs.observe(section, { childList: true, subtree: true });
  setTimeout(() => obs.disconnect(), 30000);
})();
